import { render, staticRenderFns } from "./robot.vue?vue&type=template&id=18cc3f9d&scoped=true"
import script from "./robot.vue?vue&type=script&lang=js"
export * from "./robot.vue?vue&type=script&lang=js"
import style0 from "./robot.vue?vue&type=style&index=0&id=18cc3f9d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cc3f9d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18cc3f9d')) {
      api.createRecord('18cc3f9d', component.options)
    } else {
      api.reload('18cc3f9d', component.options)
    }
    module.hot.accept("./robot.vue?vue&type=template&id=18cc3f9d&scoped=true", function () {
      api.rerender('18cc3f9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clue/components/robot.vue"
export default component.exports